import React from "react";
import ProductCard from "./ProductCard";

function ProductSection({ title, sectionIdx, products }) {

  const sectionProducts = products
    ?.filter((item) => item.title && item.price)
    ?.slice(0, 8); // show 8 products

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="text-base font-semibold text-slate-900">{title}</h2>
        <button className="text-xs font-semibold text-indigo-600">
          View all
        </button>
      </div>

      <div className="grid gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
        {sectionProducts?.map((product, idx) => (
          <ProductCard
            key={idx}
            product={product}
            accent={["orange", "blue", "green", "purple"][(sectionIdx + idx) % 4]}
          />
        ))}
      </div>
    </div>
  );
}

export default ProductSection;